<script lang="ts">
    import { Router } from "@roxi/routify";
    import { routes } from "../.routify/routes"; //automatic generated on save or "npm run build"

    // const config = {};
    const config = {
        urlTransform: {
            apply: url => `/s${url}`, //external URL
            remove: url => url.replace("/s", ""), //internal URL
        },
        // useHash: true,
    };
</script>

<Router {routes} {config} />
